import React from 'react';
import { Javascript, NodeJS, Sequelize, AWS, Redux } from '../../svg/icons';

const ProjectHeader = () => {
  return <div className="project_header"></div>;
};

export default ProjectHeader;
